export const userAEVFields = {
    userId: {
        name: "id",
        label: "User Id",
        required: false,
    },
    userSid: {
        name: "username",
        label: "Username",
        required: false,
    },
    firstName: {
        name: "first_name",
        label: "First Name",
        required: true,
    },
    lastName: {
        name: "last_name",
        label: "Last Name",
        required: true,
    },
    email: {
        name: "email",
        label: "Email",
        required: true,
    },
    phone: {
        name: "phone",
        label: "Telephone",
        required: true,
    },
    isActive: {
        name: "is_active",
        label: "Is Active",
        required: true,
    },
    createDatetime: {
        name: "create_datetime",
        label: "Create at",
        required: false,
    },
    modifyDatetime: {
        name: "modify_datetime",
        label: "Modified at",
        required: false,
    },
    modifyUserId: {
        name: "modify_user_id",
        label: "Modified By Id",
        required: false,
    },
    modifyUserName: {
        name: "modify_user_name",
        label: "Modified By",
        required: false,
    },
}


